import { render } from "./PlotTransferModal.vue?vue&type=template&id=00030922"
import script from "./PlotTransferModal.vue?vue&type=script&lang=js"
export * from "./PlotTransferModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__